function displayAgence(adresse, map, bounds) {
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode( { 'address': adresse}, function(results, status) {
        if (status === 'OK') {
            map.setCenter(results[0].geometry.location);
            var marker = new google.maps.Marker({
                map: map,
                position: results[0].geometry.location
            });
            bounds.extend(results[0].geometry.location);
        } else {
            console.log('Geocode was not successful for the following reason: ' + status);
        }
    });
}
